import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
declare var $:any;

@Component({
  selector: 'app-static-page',
  templateUrl: './static-page.component.html',
  styleUrls: ['./static-page.component.scss']
})
export class StaticPageComponent {

  public staticData:any=[];
  public loading:boolean = false;
  public currentUrl:any =this.router.url;

  constructor(public router: Router, private service: GlobalService) { 
    this.getstatic();
   }

  getstatic(){
    var url:any='';
    if(this.currentUrl=='/privacy-policy'){
      url="/privacy-policy";
    } else {
      url="/term-conditions";
    }

    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        this.staticData = response.data;
      }
    }), (error) => { this.loading =false; });
  }
}
